import React, { useCallback } from "react";

import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons/faQuestionCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IntlShape } from "react-intl";

import { showModal } from "@mapmycustomers/ui";

import styles from "./useCloseConfirmationModal.module.scss";

const useCloseConfirmationModal = (intl: IntlShape) =>
  useCallback(
    (onDiscard: () => void) => {
      showModal({
        cancelButtonProps: {
          danger: true,
          type: "default",
        },
        cancelText: intl.formatMessage({
          id: "settings.calendar.createEditPane.confirmClose.cancel",
          defaultMessage: "Leave setup",
          description: "Settings calendar create/edit pane - confirmation modal cancel",
        }),
        content: (
          <div className={styles.content}>
            {intl.formatMessage({
              id: "settings.calendar.createEditPane.confirmClose.content",
              defaultMessage:
                "If you exit, you will have to re-sync with your calendar client at a later time.",
              description: "Settings calendar create/edit pane - confirmation modal content",
            })}
          </div>
        ),
        icon: <FontAwesomeIcon className={styles.icon} icon={faQuestionCircle} />,
        okText: intl.formatMessage({
          id: "settings.calendar.createEditPane.confirmClose.ok",
          defaultMessage: "Continue setting up",
          description: "Settings calendar create/edit pane - confirmation modal ok",
        }),
        onCancel: () => {
          onDiscard();
        },
        title: (
          <div className={styles.title}>
            {intl.formatMessage({
              id: "settings.calendar.createEditPane.confirmClose.title",
              defaultMessage: "Are you sure you want to exit?",
              description: "Settings calendar create/edit pane - confirmation modal title",
            })}
          </div>
        ),
        type: "confirm",
      });
    },
    [intl]
  );

export default useCloseConfirmationModal;
